<template>
    <b-card no-body>
        <b-modal id="assign" title="Atama" no-close-on-esc no-close-on-backdrop>
            <branch-human-resources-assign-create :errors="errors" v-model="assignData"></branch-human-resources-assign-create>
            <template #modal-footer><v-executer :loading="loading" text="Ata" :action="assign"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :add-callback="createNew"
                    :items-provider="provider"
                    :fields="fields"
                    name="branch-human-resources"
                    :buttons="buttons"
                    pagination="server"
                    search>
                    <template #filters>
						<branch-human-resources-assign-filter v-on:filter="filter"></branch-human-resources-assign-filter>
					</template>
        </v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import EmployeeOperationsApi from '@/api/employee-operations'
import BranchHumanResourcesAssignCreate from './components/BranchHumanResourcesAssignCreate.vue'
import BranchHumanResourcesAssignFilter from './components/BranchHumanResourcesAssignFilter.vue'
export default {
    components:{
        BCard,
        BranchHumanResourcesAssignCreate,
        BranchHumanResourcesAssignFilter
    },
    data(){
        return{
            loading:false,
            fields:[
                {name:'Personel',key:'EmployeeFullName',sortKey:'Employee.FullName',sortable:true,thClass:'w-25'},
                {name:'Şube',key:'ResponsibleBranchName',sortKey:'ResponsibleBranch.Name',sortable:true,thClass:'w-25'},
                {name:'Başlangıç Tarihi',key:'StartDateStr',thClass:'w-25'},
                {name:'Bitiş Tarihi',key:'EndDateStr',thClass:'w-25'},
            ],
            buttons:[
                {text:"Atamayı Kaldır",key:"unassign",icon:"XSquareIcon",variant:"danger",action:this.unassign },
            ],
            assignData:{
                HREmployeeId:null,
                ResponsibleBranchId:null,
                StartDate:null,
            },
            filterData:{
                AssignmentExpired:null
            },
            errors:{}
        }
    },
    methods:{
        clearForm(){
            this.assignData.HREmployeeId = null
            this.assignData.ResponsibleBranchId = null
            this.assignData.StartDate = null
        },
        createNew(){
            this.clearForm()
            this.$showModal('assign')
        },
        provider(data){
            return EmployeeOperationsApi.HRAssignToBranch.Table({
                PaginationRequestModel:data,
                ...this.filterData
            })
        },
        filter(filter){
            this.filterData = filter
            this.$refs.table.refresh()
        },
        assign(){
            this.loading = true
            EmployeeOperationsApi.HRAssignToBranch.Assign(this.assignData).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$refs.table.refresh()
                    this.$hideModal('assign')
                }
            }).catch(err=>{
                this.$result(null,err)
                this.loading = false
            })
        },
        unassign(item){
            this.$confirm('Atamayı kaldırmak istediğinize emin misiniz?',`Bu işlem ${item.EmployeeFullName} personelinin ${item.ResponsibleBranchName} şubesi için sorumluluk atamasını kaldırcaktır ve geri alınamaz.`).then(result=>{
                if(result){
                    EmployeeOperationsApi.HRAssignToBranch.Unassign(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        }
    }
}
</script>

<style>

</style>